import { BrowserRouter } from 'react-router-dom';
import { AxiosProvider } from './lib/axios';
import { AutoEinsApp } from './main-layout';
import deDE from 'antd/locale/de_DE';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { ConfigProvider, notification } from 'antd';

export const App = (): React.ReactElement => {
    dayjs.locale('de');

    notification.config({ placement: 'bottomRight' });

    return (
        <AxiosProvider>
            <ConfigProvider
                locale={deDE}
                theme={{
                    token: {
                        colorPrimary: '#EB6910',
                    },
                    components: {
                        Layout: {
                            headerBg: '#FFFFFF',
                            footerBg: '#FFFFFF',
                            headerHeight: 120,
                        },
                        Button: {
                            borderRadius: 2,
                            primaryShadow: 'none',
                            defaultShadow: 'none',
                            dangerShadow: 'none',
                        },
                        Typography: {
                            titleMarginBottom: '0.5em',
                            titleMarginTop: 0,
                        },
                    },
                }}
            >
                <BrowserRouter>
                    <AutoEinsApp />
                </BrowserRouter>
            </ConfigProvider>
        </AxiosProvider>
    );
};

export default App;
